import { render, staticRenderFns } from "./MessageActionModal.vue?vue&type=template&id=712749aa&scoped=true&"
import script from "./MessageActionModal.vue?vue&type=script&lang=js&"
export * from "./MessageActionModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageActionModal.vue?vue&type=style&index=0&id=712749aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712749aa",
  null
  
)

export default component.exports